import React from "react";

const Java_Recursion = () => {
  return (
    <div>
      <h1>Java Recursion</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Recursion in Java.</p>
    </div>
  );
};

export default Java_Recursion;
